import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { GraduationCap, Clock } from "lucide-react";

export default function Corsi() {
  const { content } = useOutletContext() || {};
  const c = content || {};
  const [corsi, setCorsi] = useState([]);
  const [active, setActive] = useState(null);
  const [form, setForm] = useState({ nome:"", cognome:"", email:"", telefono:"" });
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/corsi").then(r => setCorsi(r.data)); }, []);

  const enroll = async () => {
    if (!form.nome || !form.email) return toast.error("Nome e email obbligatori");
    setBusy(true);
    try {
      await api.post(`/corsi/${active.id}/iscrizioni`, { course_id: active.id, ...form });
      toast.success("Iscrizione inviata!");
      setForm({ nome:"", cognome:"", email:"", telefono:"" });
      setActive(null);
    } catch { toast.error("Errore iscrizione"); }
    setBusy(false);
  };

  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="mb-10">
        <div className="tag-pill mb-3"><GraduationCap size={12}/> Formazione</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase text-white" data-testid="corsi-heading">{c.corsi_title || "Corsi del circolo"}</h1>
        <p className="mt-3 text-white/70 max-w-2xl whitespace-pre-line">{c.corsi_subtitle || ""}</p>
      </div>

      {corsi.length === 0 && <div className="card p-10 text-center text-white/70" data-testid="corsi-empty">Nessun corso attivo al momento.</div>}

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {corsi.map(c => (
          <div key={c.id} className="card p-5" data-testid={`corso-${c.id}`}>
            {c.poster_url && (
              <div className="aspect-square w-full bg-black mb-4 flex items-center justify-center overflow-hidden">
                <img src={c.poster_url} alt={c.title} className="w-full h-full object-contain"/>
              </div>
            )}
            <h3 className="font-display text-2xl uppercase">{c.title}</h3>
            <p className="mt-2 text-sm text-white/70">{c.description}</p>
            <div className="mt-3 flex items-center gap-2 text-xs font-mono uppercase text-[#FFFFFF] tracking-widest">
              <Clock size={12}/> {c.schedule}
            </div>
            <div className="mt-4 flex items-center justify-between">
              <span className="tag-pill">{c.price_on_request ? "Prezzo su richiesta" : c.price > 0 ? `€${c.price.toFixed(2)}` : "Gratuito"}</span>
              <button onClick={() => setActive(c)} className="brutal-btn brutal-btn-primary text-xs" data-testid={`enroll-${c.id}`}>
                {c.price_on_request ? "Richiedi info" : "Iscriviti"}
              </button>
            </div>
          </div>
        ))}
      </div>

      {active && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80" onClick={() => setActive(null)}>
          <div className="card p-6 max-w-md w-full" onClick={e => e.stopPropagation()}>
            <h3 className="font-display text-2xl uppercase mb-4">Iscrizione a {active.title}</h3>
            <div className="grid gap-3">
              <input placeholder="Nome" value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} className="bg-[#000000] border border-[#FFFFFF] px-3 py-3 rounded" data-testid="enroll-nome"/>
              <input placeholder="Cognome" value={form.cognome} onChange={e => setForm({...form, cognome: e.target.value})} className="bg-[#000000] border border-[#FFFFFF] px-3 py-3 rounded" data-testid="enroll-cognome"/>
              <input placeholder="Email" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="bg-[#000000] border border-[#FFFFFF] px-3 py-3 rounded" data-testid="enroll-email"/>
              <input placeholder="Telefono" value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} className="bg-[#000000] border border-[#FFFFFF] px-3 py-3 rounded" data-testid="enroll-tel"/>
              <button onClick={enroll} disabled={busy} className="brutal-btn brutal-btn-primary" data-testid="enroll-submit">
                {busy ? "Invio..." : "Conferma iscrizione"}
              </button>
              <button onClick={() => setActive(null)} className="text-xs text-white/70 hover:text-white">Annulla</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
